import styled from "styled-components";

export const BodyLoading = styled.div`
position:absolute;
top:50%;
left:47%;
transform: translate(-50%,-50%);


display: flex;


p{
   margin-left:12px;
   color:#fff;
   margin-bottom:0;
   font-size:12px;
}

`